import React, { useState } from "react";

import { Layout, MetaTag } from "src/components";
import { ConceptForm } from "../../components";
import { Card, Col, Row, Spin } from "antd";

const CreateView = (props: any) => {
    const { onFinish, onFinishFailed } = props;

    return (
        <Layout
            titles={[
                { name: "Concepts", link: "/concept" },
                { name: "New", link: "" },
            ]}
        >
            <MetaTag title="Add Concept" />
            <Row justify="center" align="middle">
                <Col xs={12} lg={20} md={24}>
                    <Card
                        style={{ borderRadius: "8px", padding: "12px" }}
                        title={"Concept Create"}
                        bordered={true}
                    >
                        <ConceptForm
                            onFinish={onFinish}
                            onFinishFailed={onFinishFailed}
                        />
                    </Card>
                </Col>
            </Row>
        </Layout>
    );
};

export default CreateView;
